<template>
  <div class="evento-imagenes">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Evento">
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="cliente"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Evento"
              label-for="evento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="evento"
                :value="evento"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Imágenes / Documentos" class="galeria-imagenes">
          <b-btn class="card-header-add" 
              variant="primary" 
              size="sm"
              @click.prevent="agregarImagenes">
            <i class="fa fa-plus"></i>
          </b-btn>
          <b-row v-if="seleccionImagenes">
            <b-col>
              <b-form>
                <b-form-group
                    description="Imágenes (jpg, png o jpeg) o Documentos PDF de hasta 3MB">
                  <b-form-file 
                    v-model="files" 
                    class="mt-3" 
                    accept=".jpg, .png, .jpeg, .pdf" 
                    placeholder="Seleccione una o más imágenes o archivos, o arrastrelos hasta aquí"
                    multiple>
                  </b-form-file>
                  <b-input-group-append 
                    class="filter-search-icons" 
                    @click="agregarImagenes">
                    <b-input-group-text>
                      <i class="fa fa-remove"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <!-- <template
              v-for="{ id, fileName, url, key } in imagenes"> -->
            <template
              v-for="imagen in imagenes">
              <b-col :key="imagen.id" cols="12" md="4">
                <b-card no-header class="galeria-imagen">
                  <template v-if="isImagen(imagen.fileName)">
                    <b-img fluid
                      @click="consultarImagen(imagen.url)"
                      :src="imagen.url"></b-img>
                  </template>
                  <template v-if="isPDF(imagen.fileName)">
                    <div class="galeria-pdf">
                      <i class="fa fa-file-pdf-o fa-2x" @click="consultarPDF(imagen.url, imagen.fileName)"></i>
                      <label @click="consultarPDF(imagen.url, imagen.fileName)">{{ imagen.fileName }}</label>
                    </div>
                    <!-- <label>PDF</label> -->
                  </template>
                  <div class="titulo">
                    <h3 v-if="imagen.titulo != ''">{{ imagen.titulo }}</h3>
                  </div>
                  <div class="footer">
                    <b-button size="sm" variant="primary" class="footer-button" 
                      @click.prevent="editarDatos(imagen)">Editar</b-button>

                    <b-button size="sm" variant="danger" class="footer-button" 
                      @click.prevent="borrarImagen(imagen.id)">Borrar</b-button>
                  </div>
                </b-card>
              </b-col>
            </template>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <b-modal ref="imagenEdicionModal"
        title="Datos del Documento"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-imagen-edicion
        :imagen="imagen"
        @close="closeEdicionImagen">
      </app-imagen-edicion>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Imagen from  '../shared/imagenModal.vue';
import ImagenEdicion from  './Imagen.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'eventoImagenes/getField',
  mutationType: 'eventoImagenes/updateField',
});

export default {
  name: 'EventoImagenes',
  components: {
    appImagen: Imagen,
    appImagenEdicion: ImagenEdicion,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      files: [],
      uploaded: [],
      seleccionImagenes: false,
      selectedImageUrl: '',
      imagen: null,

      labelCols: 1
    }
  },
  computed: {
    ...mapFields([
      'cliente',
      'evento',
      'imagenes',
    ]),
  },
  created() {
    let eventoId = this.$route.params.id;

    this.showSpinner();
    this.$store.dispatch('eventoImagenes/inicializar', eventoId)
      .then(() => this.getImagenes())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    getImagenes() {
      this.showSpinner();
      this.$store.dispatch('eventoImagenes/getImagenes')
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    isImagen(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'jpg' 
          || extension.toLowerCase() == 'png') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'jpeg') {
        return true;
      }

      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    editarDatos (imagen) {
      this.imagen = imagen;
      this.$refs.imagenEdicionModal.show();
    },
    closeEdicionImagen() {
      this.$refs.imagenEdicionModal.hide();
    },
    borrarImagen (imagenId) {
      this.showModalConfirm('¿Desea eliminar la imagen o archivo seleccionado?', 
        this.borrar.bind(this, imagenId), 'Si', 
        null, 'No')
    },
    borrar(imagenId) {
      this.showSpinner();
      this.$store.dispatch('eventoImagenes/removeImagen', imagenId)
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner())
    },
    agregarImagenes() {
      this.seleccionImagenes = !this.seleccionImagenes;
    },
    uploadFiles() {
      if (this.files) {
        if (this.files.length != 0) {
          this.uploaded = [];

          this.showSpinner();

          this.files.forEach(file => {
            let params = {
              file: file
            }

            this.uploaded.push(file);

            this.$store.dispatch('eventoImagenes/addImagen', params)
              .then( () => this.fileUploaded(file))
              .catch( error => {
                this.hideSpinner();
                this.showErrorMsj (error);
              });
          });
        }
      }
    },
    fileUploaded(file) {
      console.log('Uploaded');

      let index = this.uploaded.findIndex(uploadedFile => uploadedFile.name == file.name);

      if (index != -1) {
        this.uploaded.splice(index, 1);

        if (this.uploaded.length == 0) {
          this.files = [];
          this.seleccionImagenes = false;
          this.hideSpinner();
        }
      }
    },
    descargarImagen(imageUrl, imagenName) {
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, imagenName);
        });
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    consultarPDF(url, fileName) {
      window.open(url, '_blank');
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  watch: {
    'files' : function(newVal, oldVal) {
      this.uploadFiles();
    },    
  }   
}
</script>
